<template>
<span>
    <v-layout mb-4>
        <v-flex xs10 ml-3>
            <h2 class="lime--text lighten-1 pt-3">Gerenciar Departamento - Inclusão</h2>
        </v-flex>
        <v-flex xs2 mr-3 text-right>
            <v-btn color="blue-grey" class="black--text" :to="{name: 'product-depts'}">
                <v-icon dark>keyboard_arrow_left</v-icon>
                Voltar
            </v-btn>
        </v-flex>
    </v-layout>
    <form-product-depts :btnLabel="btnLabel"></form-product-depts>
</span>
</template>

<script>
import FormProductDeptsComponent from "./partial/FormProductDeptsComponent";

export default {
    name: "AddProductDeptsComponent",
    data() {
        return {
            btnLabel: 'Incluir'
        }
    },
    methods: {

    },
    components: {
        formProductDepts: FormProductDeptsComponent,
    }
};
</script>

<style scoped>

</style>
